import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

public bannerHeighPix = 150

public advisors = [ {id: 28, name: "Mary"}] 

public clientServices = [{id: 32, fullName: "Gouri Misra"}, {id: 69, fullName: "Elizabeth	Brunson"}]

public management = [{fullName:"Mark T. Hebner"}, {fullName: "Wes Long"}, {fullName: "Anne Page"}, {fullName: "Shareen Balkey"}, {fullName: "Michelle Ojeda"}, {fullName: "Trevor Kensey"}]

advisorsGetIdFromName(name) {
  return this.advisors.find(x=> {
// $&("name", name)
    return x.name.toLowerCase()==name.toLowerCase()
  }).id
}

managersGetName(fullName) {
  return this.management.find(x=> {
// $&("fullName", fullName)
    return x.fullName.toLowerCase()==fullName.toLowerCase()
  }).fullName
}

cssGetIdFromName(fullName) {
  return this.clientServices.find(x=> {
// $&("fullName", fullName)
    return x.fullName.toLowerCase()==fullName.toLowerCase()
  }).id
}

constructor() { }

}
